import React from "react";
import { FileText } from "lucide-react";
import Text from "@src/lib/ui/Text";

interface CanvasEmptyStateProps {
  isLoading?: boolean;
}

const CanvasEmptyState: React.FC<CanvasEmptyStateProps> = ({
  isLoading = false,
}) => {
  const getEmptyStateContent = () => {
    if (isLoading) {
      return {
        icon: <FileText className="h-16 w-16 text-purple-5" />,
        title: (
          <Text variant="body-title" className="text-gray-7">
            Writing your outline...
          </Text>
        ),
      };
    }

    return {
      icon: <FileText className="h-16 w-16 text-gray-5" />,
      title: (
        <Text variant="body-title" className="text-gray-6">
          Your canvas is empty
        </Text>
      ),
    };
  };

  const { icon, title } = getEmptyStateContent();

  return (
    <div className="flex flex-1 items-center justify-center p-8">
      <div className="max-w-sm space-y-4 text-center flex flex-col items-center">
        {icon}
        {title}
      </div>
    </div>
  );
};

export default CanvasEmptyState;
